const emojis = ["😿", "😞", "😒", "😫", "😕", "💔", "🙄", "😐", "🤔"];

export function getRandomNegativeEmoji() {
  return emojis[Math.floor(Math.random() * emojis.length)];
}

export default emojis;
